module.exports = __webpack_public_path__ + "static/media/arrow-right-outline-color.8d8fb9e5.svg";